import {OrganisationRepository} from '../repository/OrganisationRepository';

class Organisation {
    static init() {
        let rowID = 1;
        $(document).on('click', '.add-level, .remove-level', function() {
            let currentRow = $(this).closest('.level-row');
            let rowsCount = $('.level-row').length;

            if($(this).hasClass('remove-level')){
                if(rowsCount <= 1) {
                    Toast.fire({
                        icon: 'info',
                        title: 'There must be, at least, one Level for a organisation. If this organisation should have no levels, you may use the organisation\'s name as Level Title and set position to One (1)'
                    })
                } else {
                    currentRow.slideUp(function(){
                        currentRow.remove();
                        if(rowID > 1){
                            rowID--;
                        }
                    });
                }
                return false;
            }

            let newRow = `
            <div class="input-group mb-3 level-row">
                <button class="btn bg-gradient-dark shadow-none" type="button">Name</button>
                <input type="text" class="form-control px-2" name="level[${rowID}][name]" placeholder="E.g.: General Conference">
                <button class="btn bg-gradient-dark shadow-none" type="button">Level</button>
                <input type="number" class="form-control px-2 level-position" name="level[${rowID}][position]" placeholder="E.g.: 1">
                <button class="btn bg-gradient-danger shadow-none remove-level" type="button"><span class="fas fa-minus"></span></button>
                <button class="btn bg-gradient-success shadow-none add-level" type="button"><span class="fas fa-plus"></span></button>
            </div>
           `;

            currentRow.after(newRow)
            rowID++;
        });
    }
}

export default Organisation
